import script from "./Progressbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Progressbar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__